import React, { Fragment, useEffect, useRef } from 'react'
import ChangeProfilePicture from '../../../_helpers/change-profile-picture'

import { faUserMd } from '@fortawesome/free-solid-svg-icons'
import { faBuilding } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Row, Col, Button } from 'react-bootstrap'

import './style.css'

export default function Profile({
  bio,
  client,
  licensed,
  uploading,
  handleError,
  handleProfile,
}) {

  const contentDOM = useRef()

  useEffect(() => {
    contentDOM.current.innerHTML = bio
  });

  return (
    <Row>
      <Fragment>
        <Col lg='12' xl='4'>
          <Row className='text-center'>
            <Col lg='12'>
              <h2 className='fw-bold'>
                {licensed.firstName} {licensed.lastName}
              </h2>
            </Col>
            <Col lg='12' className='d-flex justify-content-center'>
              <ChangeProfilePicture
                uploading={uploading}
                profileUrl={licensed.profileUrl}
                handleUpload={handleProfile}
                handleError={handleError}
              />
            </Col>

            <Col lg='12' className='mb-1'>
              <small>
                <FontAwesomeIcon
                  icon={faUserMd}
                  className='fa-fw text-muted opacity-50'
                />
                &nbsp; {licensed.type}
              </small>
            </Col>
            <Col lg='12' className='text-muted'>
              <small>
                <FontAwesomeIcon
                  icon={faBuilding}
                  className='fa-fw opacity-50'
                />
                &nbsp; {client.name}
              </small>
            </Col>
          </Row>
          <br />
          {client.landingActions &&
            client.landingActions.data.map((action, index) => {
              return (
                <Row key={index} className='my-4 text-center'>
                  <Col
                    xs={{ span: 12, offset: 0 }}
                    sm={{ span: 10, offset: 1 }}
                  >
                    <Button
                      size='lg'
                      onClick={() => null}
                      className='w-100 call__to__action--btn'
                    >
                      {action.data.title}
                    </Button>
                  </Col>
                </Row>
              )
            })}
          <br />
        </Col >
        <Col>
          <Row>
            <Col>
              <div id='bio-preview' ref={contentDOM}></div>
            </Col>
          </Row>
        </Col>
      </Fragment >
    </Row >
  )
}
